import AreasIndex from '@/views/settings/areas/AreasIndex.vue'
import AreaAdd from '@/views/settings/areas/AreaAdd.vue'
import AreaEdit from '@/views/settings/areas/AreaEdit.vue'

export default [
  {
    path: '/settings/areas',
    name: 'settings.areas.index',
    component: AreasIndex,
    meta: { title: 'settings.areas.indexTitle', requiresAuth: true, requiredPerm: 'areas.display' },
    children: [
      {
        path: 'add',
        name: 'settings.areas.create',
        component: AreaAdd,
        meta: { title: 'settings.areas.addTitle', requiresAuth: true, requiredPerm: 'areas.create' }
      },
      {
        path: 'edit/:id',
        name: 'settings.areas.edit',
        component: AreaEdit,
        props: true,
        meta: { title: 'settings.areas.editTitle', requiresAuth: true, requiredPerm: 'areas.update' }
      }
    ]
  }
]
